import { render } from "./GalleryPopup.vue?vue&type=template&id=52949251&scoped=true"
import script from "./GalleryPopup.vue?vue&type=script&lang=js"
export * from "./GalleryPopup.vue?vue&type=script&lang=js"

import "./GalleryPopup.vue?vue&type=style&index=0&id=52949251&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52949251"]])

export default __exports__